import type { LegacyTableColumn, LegacyTableRow } from "@wayflyer/flyui-dataviz";
import { escapeCsvCell } from "shared-utils";

const SORT_PREFIX = "sort_";

// Mirrors the legacy CSV behaviour: prefer the formatted display value, falling
// back to the raw `sort_<id>` value when the display cell is empty.
const toCellValue = (row: LegacyTableRow, col: LegacyTableColumn): string => {
  const display = row[col.id];
  if (display !== undefined && display !== "") {
    return String(display);
  }
  const raw = row[`${SORT_PREFIX}${String(col.id)}`];
  return raw !== undefined ? String(raw) : "";
};

// Cell encoding (escaping + formula-injection neutralisation) lives in the shared
// `escapeCsvCell` helper so the security-sensitive logic isn't duplicated here.
export const buildCsv = (columns: LegacyTableColumn[], data: LegacyTableRow[]): string => {
  const header = columns.map((col) => escapeCsvCell(col.name)).join(",");
  const lines = data.map((row) => columns.map((col) => escapeCsvCell(toCellValue(row, col))).join(","));
  return [header, ...lines].join("\n");
};

export const downloadCsv = (filename: string, columns: LegacyTableColumn[], data: LegacyTableRow[]): void => {
  if (typeof window === "undefined" || typeof document === "undefined") {
    return;
  }
  const csv = buildCsv(columns, data);
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename || "table.csv";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
